export function logoSlider() {
    let sliderContainer = $(".logos-block");
    let sliderContainerWidth = sliderContainer.width();
    let $logos = $(".logo-container");
    let logoWidth = 140;
    let logoQuantity = $logos.length;
    let columnGap = 30;
    let marginForFullHd = 32;
    let initSlider = () => {

        sliderContainer.slick({
            infinite: true,
            slidesToScroll: 1,
            slidesToShow: 1,
            mobileFirst: true,
            arrows: false,
            dots: true,
            responsive: [
                {
                    breakpoint: 380,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 568,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 5
                    }
                },
            ]
        });
    };

    if ($(window).width() >= 1800) {
        columnGap = 41;
    } else {
        marginForFullHd = 0;
    }

    if ($(window).width() >= 1200) {

        if (sliderContainerWidth < (logoWidth * logoQuantity + columnGap * (logoQuantity - 1) - marginForFullHd)) {
            initSlider();
        }

        $(window).on("resize", () => {
            if ($(window).width() >= 1800) {
                columnGap = 41;
                marginForFullHd = 32;
            } else {
                columnGap = 30;
                marginForFullHd = 0;
            }
            sliderContainerWidth = sliderContainer.width();

            if (sliderContainer.hasClass("slick-initialized")) {
                if (sliderContainerWidth > (logoWidth * logoQuantity + columnGap * (logoQuantity - 1) - marginForFullHd)) {
                    sliderContainer.slick("unslick");
                }
            } else {
                if (sliderContainerWidth < (logoWidth * logoQuantity + columnGap * (logoQuantity - 1) - marginForFullHd)) {
                    initSlider();
                }
            }
        });
    } else {
        if (!sliderContainer.hasClass("slick-initialized")) {
            initSlider();
        }
    }
};


// WEBPACK FOOTER //
// ./assets/js/modules/logoSlider.js